import { Feature, SubscriptionProduct } from './subscription-product';

export const planner: SubscriptionProduct = {
    title: 'Planner',
    subtitle: 'Start planning your decks now!',
    price: '$1.99',
    prettyPrice: '<s>$3.99</s> $1.99',
    promptText: 'Start planning now!',
    subscriptionFrequency: 'per month',
    features: [
        {
            isPending: false,
            shortDescription: 'Everything in Free, plus:'
        },
        {
            isPending: false,
            shortDescription: 'Always keep this price!'
        },
        {
            isPending: false,
            shortDescription: 'Immediate access to our premium features as soon as they\'re available'
        },
        {
            isPending: true,
            shortDescription: 'Picture-based collection management'
        },
        {
            isPending: true,
            shortDescription: 'Deck Planning Assistant'
        },
        {
            isPending: true,
            shortDescription: 'Tournament Registration Assistant'
        }
    ],
    signupType: 'planner'
};

export const free: SubscriptionProduct = {
    title: 'Free',
    subtitle: 'Jump into the site and poke around',
    price: '$0',
    prettyPrice: '$0',
    promptText: 'Sign up now!',
    subscriptionFrequency: 'per month',
    features: [
        {
            isPending: false,
            shortDescription: 'Advanced Search Tools for Researching Cards'
        },
        {
            isPending: false,
            shortDescription: 'Collection Management'
        },
        {
            isPending: false,
            shortDescription: 'Rules-Assisted Deck Planning and Construction'
        },
        {
            isPending: false,
            shortDescription: 'Share your decks publicly and/or with friends'
        },
        {
            isPending: false,
            shortDescription: 'Like your favorite community decks, see what\'s popular!'
        },
        {
            isPending: false,
            shortDescription: 'Snapshots of the current most popular cards'
        },
        {
            isPending: false,
            shortDescription: 'Hobby News'
        },
    ],
    signupType: 'free'
};

export const products: SubscriptionProduct[] = [free, planner];
